import React from 'react';

import SatCheckBox from '@components/common/satUI/SatCheckBox';
import SatRadio from '@components/common/satUI/SatRadio';

const SatQuestionArea = props => {
  const {
    title,
    selectValue,
    options = [],
    onClick = () => {},
    useType,
    locked,
    name,
    notice,
    error,
    listType,
    customStyleClass,
    questionInfo,
  } = props;

  return (
    <React.Fragment>
      <div className="insu-box">
        <div
          className={`txt-question ${customStyleClass ? customStyleClass : ''}`}
          style={{ whiteSpace: 'pre-wrap' }}
        >
          {typeof title === 'function' ? title() : title}
          {error ? (
            <p className="text-info2 ico-type error">{error}</p>
          ) : (
            notice && <p className="text-info2 ico-type">{notice}</p>
          )}
        </div>
        {useType === 'btn' && (
          <div className="btn-group col2">
            {options.map((option, index) => {
              return (
                <React.Fragment key={index}>
                  <SatRadio
                    value={selectValue}
                    options={[{ label: option.label, value: option.value }]}
                    onChange={value => onClick(value.value)}
                    name={name}
                    type={'button'}
                    locked={
                      locked && selectValue === option.value ? true : false
                    }
                    disabled={
                      locked && selectValue !== option.value ? true : false
                    }
                  />
                </React.Fragment>
              );
            })}
          </div>
        )}
        {useType === 'checkBox' && (
          <div className={listType ? listType : 'inp-list'}>
            {options.map((option, index) => {
              return (
                <React.Fragment key={index}>
                  <SatCheckBox
                    value={[selectValue && selectValue.includes(option.value)]}
                    options={[{ label: option.label, value: option.value }]}
                    onChange={value => onClick(value, option.value)}
                  />
                </React.Fragment>
              );
            })}
            {questionInfo && <div className="mgt-20">{questionInfo}</div>}
          </div>
        )}
        {useType === 'radio' && (
          <div className={listType ? listType : 'inp-list'}>
            {options.map((option, index) => {
              return (
                <React.Fragment key={index}>
                  <SatRadio
                    value={selectValue}
                    options={[{ label: option.label, value: option.value }]}
                    onChange={value => onClick(value.value)}
                    name={name}
                  />
                </React.Fragment>
              );
            })}
          </div>
        )}
      </div>
      {/* {suffix && suffix()} */}
    </React.Fragment>
  );
};

export default SatQuestionArea;
